/**
 * @generated SignedSource<<fb3cbc8103e4883df19b7eb9a01a0b63>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useChangeTeamMembershipJoinMutation$variables = {
  teamId: string;
};
export type useChangeTeamMembershipJoinMutation$data = {
  readonly me: {
    readonly joinTeams: {
      readonly currentStoreUser: {
        readonly id: string;
        readonly teams: ReadonlyArray<{
          readonly id: string;
        }>;
      } | null;
      readonly id: string;
    };
  };
};
export type useChangeTeamMembershipJoinMutation = {
  response: useChangeTeamMembershipJoinMutation$data;
  variables: useChangeTeamMembershipJoinMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "teamId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MeMutation",
    "kind": "LinkedField",
    "name": "me",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "items": [
              {
                "kind": "Variable",
                "name": "teamIds.0",
                "variableName": "teamId"
              }
            ],
            "kind": "ListValue",
            "name": "teamIds"
          }
        ],
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "joinTeams",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "StoreUser",
            "kind": "LinkedField",
            "name": "currentStoreUser",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChangeTeamMembershipJoinMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useChangeTeamMembershipJoinMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "2adf506d4da22a64c2b07e415723cc6a",
    "id": null,
    "metadata": {},
    "name": "useChangeTeamMembershipJoinMutation",
    "operationKind": "mutation",
    "text": "mutation useChangeTeamMembershipJoinMutation(\n  $teamId: ID!\n) {\n  me {\n    joinTeams(teamIds: [$teamId]) {\n      id\n      currentStoreUser {\n        id\n        teams {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc3a882eb450436553889fd0f0d680c7";

export default node;
